/**
 * Created by Admin on 2017/12/20.
 */
import Vue from 'vue';
import Router from 'vue-router';

const _import = require('./_import_' + process.env.NODE_ENV);

Vue.use(Router);
/* 配置路由 */
const originalPush = Router.prototype.push // 点击element-ui 子菜单 两次报错解决
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// export default new Router({
const router = new Router({
  routes: [{
    path: '/',
    component: _import('mobileEntranceIndex/index'),
    redirect: '/mailProjectDetail',
    children: [{
      path: '/mailProjectDetail',
      name: 'mailProjectDetail',
      component: _import('mobileEntranceIndex/mailProjectDetail')
    },
    {
      path: '/mailProjectDetail_type1',
      name: 'index',
      component: _import('mobileEntranceIndex/mailProjectDetail_type1')
    },
    {
      path: '/mailProjectDetail_type1',
      name: 'mailProjectDetail_type1',
      component: _import('mobileEntranceIndex/mailProjectDetail_type1')
    },
    {
      path: '/mailProjectDetail_type2',
      name: 'mailProjectDetail_type2',
      component: _import('mobileEntranceIndex/mailProjectDetail_type2')
    },
    {
      path: '/login',
      name: 'mailProjectLogin',
      component: _import('mobileEntranceIndex/login')
    },
    {
      path: '/login',
      name: 'login',
      component: _import('mobileEntranceIndex/login')
    },
    {
      path: '/manualPushLogin',
      name: 'manualPushLogin',
      component: _import('mobileEntranceIndex/manualPushLogin')
    },
    {
      path: '/prefectInvestPreference',
      name: 'prefectInvestPreference',
      component: _import('mobileEntranceIndex/prefectInvestPreference')
    }]
  },
  {
    path: '/manualPush',
    component: _import('mobileEntranceIndex/manualPush')
  },
  {
    path: '/eventDetails',
    name: 'eventDetails',
    meta: {
      title: '活动详情'
    },
    component: _import('mobileEntranceIndex/eventDetails') // 活动详情
  },
  {
    path: '/applyList',
    name: 'applyList',
    meta: {
      title: '已报名'
    },
    component: _import('mobileEntranceIndex/applyList') // 报名列表
  },
  {
    path: '/projectLists',
    name: 'projectLists',
    meta: {
      title: '已报名'
    },
    component: _import('mobileEntranceIndex/projectLists') // 项目列表
  },
  {
    path: '/inWts',
    name: 'inWts',
    meta: {
      title: '进入微天使'
    },
    component: _import('mobileEntranceIndex/inWts') // 进入微天使
  },
  {
    path: '/fabuActive',
    name: 'fabuActive',
    meta: {
      title: '发布活动'
    },
    component: _import('mobileEntranceIndex/fabuActive') // 发布活动
  },
  {
    path: '/createPro',
    name: 'createPro',
    meta: {
      title: '创建项目'
    },
    component: _import('mobileEntranceIndex/createPro') // 创建项目
  },
  {
    path: '/field',
    name: 'field',
    meta: {
      title: '领域'
    },
    component: _import('mobileEntranceIndex/field') // 领域
  },
  {
    path: '/region',
    name: 'region',
    meta: {
      title: '地区'
    },
    component: _import('mobileEntranceIndex/region') // 地区
  },
  {
    path: '/signForm',
    name: 'signForm',
    meta: {
      title: '报名'
    },
    component: _import('mobileEntranceIndex/signForm') // 报名表单
  },
  {
    path: '/signSuccess',
    name: 'signSuccess',
    meta: {
      title: '报名成功'
    },
    component: _import('mobileEntranceIndex/signSuccess') // 报名成功
  },
  {
    path: '*',
    redirect: '/login' // 默认首页
  }]
});
// beforeEach是router的钩子函数，在进入路由前执行
router.beforeEach((to, from, next) => {
  // 判断是否有标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 执行进入路由，如果不写就不会进入目标页
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/mobileEntranceRouter.js